import { setContext } from '@apollo/client/link/context';

import SecureStore from '../utils/secureStore';

const authLink = setContext((_, { headers }) => {
  const accessToken = SecureStore.getAccessToken();
  return {
    headers: {
      ...headers,
      authorization: accessToken ? `Bearer ${accessToken}` : ''
    }
  };
});

export default authLink;
